import React, { useState, useEffect } from 'react'
import './RSVP.css'
import { useParams, useNavigate } from 'react-router-dom'
import axios from 'axios'
import './SaveTheDate.css';
import icon from '../Assets/Icons/saveTheDate.png'
import fdm from '../Assets/fd-logo.png'
import moment from 'moment';
import acceptIcon from '../Assets/Icons/rsvp-accept.png'
import declineIcon from '../Assets/Icons/rsvp-decline.png'
import starsLeft from '../Assets/Icons/stars-left.png'
import starsRight from '../Assets/Icons/stars-right.png'
import heartsLeft from '../Assets/Icons/hearts-left.png'
import heartsRight from '../Assets/Icons/hearts-right.png'
import RsvpInvitationDetails, { getInviteWording } from './RsvpInvitationDetails'
import WeddingWebsiteCallout from './WeddingWebsiteCallout'
import { showMealChoicesForGuest } from '../utils/rsvpDisplay'

const RSVPPreview = () => {
    const { clientId } = useParams()
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const [guestData, setGuestData] = useState(null)
    const [weddingData, setWeddingData] = useState(null)
    const [weddingDate, setWeddingDate] = useState("");
    const [clientName, setClientName] = useState("");
    const [spouse, setSpouse] = useState("");
    const [canAttend, setCanAttend] = useState("");
    const [previewInvitedTo, setPreviewInvitedTo] = useState('All day');
    const [giftRegistryMsg, setGiftRegistryMsg] = useState("Your presence is the greatest gift, but if you'd like to give something, a contribution to our honeymoon fund would mean the world!")
    const [isReadOnly, setIsReadOnly] = useState(true)
    const [guestName, setGuestName] = useState("")
    const [guestEmail, setGuestEmail] = useState("")
    const [guestPhone, setGuestPhone] = useState("")
    const [guestDietary, setGuestDietary] = useState("")
    const [guestStarter, setGuestStarter] = useState("")
    const [guestMain, setGuestMain] = useState("")
    const [guestDessert, setGuestDessert] = useState("")


    const loadPreviewData = () => {
        setLoading(true)

        axios.post(`${process.env.REACT_APP_API}/weddings/get-rsvp-preview-by-client`, { clientId })
            .then((res) => {
                setGuestData(res.data.guest)
                setWeddingData(res.data.wedding)
                setWeddingDate(res.data.wedding.weddingDate)
                setClientName(res.data.wedding.clientName)
                setSpouse(res.data.wedding.spouseName)
                setGiftRegistryMsg(res.data.wedding.giftRegistry?.message || "Your presence is the greatest gift, but if you'd like to give something, a contribution to our honeymoon fund would mean the world!")

                // Check if guest has already responded and set canAttend state
                const guestResponse = res.data.guest.RSVP?.response;
                if (guestResponse === 'Accept') {
                    setCanAttend(true);
                } else if (guestResponse === 'Decline') {
                    setCanAttend(false);
                }

                // Check if RSVP is complete and set read-only state
                if (res.data.guest.RSVP?.complete === true) {
                    setIsReadOnly(true);
                }

                // Initialize form fields with guest data
                setGuestName(res.data.guest.name || "")
                setGuestEmail(res.data.guest.email || "")
                setGuestPhone(res.data.guest.number || "")
                setGuestDietary(res.data.guest.dietaryRequirements || "")
                setGuestStarter(res.data.guest.mealChoices?.starter || "")
                setGuestMain(res.data.guest.mealChoices?.main || "")
                setGuestDessert(res.data.guest.mealChoices?.dessert || "")

                // Plus ones data is already available in guestData

                setLoading(false)
            })
            .catch((error) => {
                console.error('Error fetching RSVP preview data:', error)
                setLoading(false)
                alert('There was an error loading the preview. Please try again.')
            })
    }

    // Load preview data on component mount
    useEffect(() => {
        if (clientId) {
            loadPreviewData()
        }
    }, [clientId])

    return (
        <>
            <div className="rsvp-container">
                <div className="header">
                    <h1 id="you">YOU</h1>
                    <h2 id="are">are</h2>
                    <h1 id="invited">INVITED</h1>
                </div>

                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '10px',
                    marginTop: -95,
                    marginBottom: 20,
                }}>
                    <p style={{ fontSize: 14, color: '#666', margin: 0 }}>Preview as</p>
                    <div style={{
                        display: 'flex',
                        gap: '8px',
                        backgroundColor: '#eef2f8',
                        borderRadius: '999px',
                        padding: '4px',
                    }}>
                        {['All day', 'Evening'].map((option) => (
                            <button
                                key={option}
                                type="button"
                                onClick={() => setPreviewInvitedTo(option)}
                                style={{
                                    border: 'none',
                                    borderRadius: '999px',
                                    padding: '8px 16px',
                                    fontSize: 14,
                                    cursor: 'pointer',
                                    backgroundColor: previewInvitedTo === option ? '#4D8495' : 'transparent',
                                    color: previewInvitedTo === option ? '#fff' : '#454C5C',
                                }}
                            >
                                {option === 'All day' ? 'All day' : 'Evening only'}
                            </button>
                        ))}
                    </div>
                </div>

                <p style={{ fontSize: 20, marginBottom: 30 }}>to the {getInviteWording(previewInvitedTo)} of</p>

                <div className="rsvp-names">
                    <p>{clientName ? clientName : ""} {clientName && spouse ? "&" : ""}</p>
                    <p>{spouse ? spouse : ""}</p>
                </div>

                <img
                    src={icon}
                    alt="Save the date icon"
                    className="icon"
                />

                <RsvpInvitationDetails
                    wedding={weddingData}
                    weddingDate={weddingDate}
                    invitedTo={previewInvitedTo}
                    giftRegistryMsg={giftRegistryMsg}
                />

                <div>
                    <h2 className="rsvp-blue-header">rsvp</h2>
                    <p className='rsvp-subheader-black'>Can you join us for the big day?</p>

                    <div style={{ display: 'flex', gap: '15px', width: '100%', maxWidth: '500px', margin: '30px auto' }}>
                        <div
                            style={{
                                flex: 1,
                                backgroundColor: '#dde4f3',
                                borderRadius: '10px',
                                padding: '20px 15px',
                                textAlign: 'center',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-evenly',
                                gap: '10px',
                                opacity: 0.7
                            }}
                        >
                            <img src={acceptIcon} alt="Accept" style={{ width: '26px', height: '26px', objectFit: 'contain' }} />
                            <p className="rsvp-btn-txt">Accept with pleasure</p>
                        </div>

                        <div
                            style={{
                                flex: 1,
                                backgroundColor: '#e8ecf4',
                                borderRadius: '10px',
                                padding: '20px 15px',
                                textAlign: 'center',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-evenly',
                                gap: '10px',
                                opacity: 0.3
                            }}
                        >
                            <img src={declineIcon} alt="Decline" style={{ width: '26px', height: '26px', objectFit: 'contain' }} />
                            <p className="rsvp-btn-txt">Regretfully decline</p>
                        </div>
                    </div>

                    <p style={{
                        textAlign: 'center',
                        color: '#666',
                        fontSize: '14px',
                        fontStyle: 'italic',
                        maxWidth: '500px',
                        margin: '10px auto 20px'
                    }}>
                        This is a preview of how your RSVP will look to guests.
                    </p>

                    {weddingData?.RSVPReplyByDate &&
                        <>
                            <p className='rsvp-subheader-black'>Kindly reply by</p>
                            <p className='rsvp-subheader-black'>{moment(weddingData?.RSVPReplyByDate).format('Do MMMM YYYY')}</p>
                        </>

                    }
                </div>
                <div className="rsvp-line-break"></div>

                {canAttend &&
                    <>
                        <div id='accept-container' style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <div className="rsvp-flourish">
                                <img src={starsLeft} alt="" className="rsvp-flourish-left" />
                                <h2 className="rsvp-blue-header" style={{ color: '#323232' }}>Yay!</h2>
                                <img src={starsRight} alt="" className="rsvp-flourish-right" />
                            </div>

                            <p className='rsvp-subheader-black' style={{ marginTop: 20 }}>WE CAN’T WAIT TO <br /> CELEBRATE WITH YOU!</p>

                        </div>

                        <div className="rsvp-line-break"></div>

                        <div>
                            <h2 className="rsvp-blue-header">Your info</h2>
                            <p style={{ margin: "20px auto", textAlign: "center", width: "80%" }}>
                                {isReadOnly ? "Your confirmed details" : "Please confirm a few details so we can plan everything just right."}
                            </p>

                            <form>
                                <p style={{ fontWeight: 'bold' }}>Your Details</p>
                                <label>Your name</label>
                                <input
                                    type="text"
                                    value={guestName}
                                    readOnly={true}
                                />
                                <label>Your email</label>
                                <input
                                    type="email"
                                    value={guestEmail}
                                    readOnly={true}
                                />
                                <label>Your phone number</label>
                                <input
                                    type="tel"
                                    value={guestPhone}
                                    readOnly={true}
                                />
                            </form>
                        </div>

                        {showMealChoicesForGuest(previewInvitedTo, weddingData) && (
                        <>
                        <div className="rsvp-line-break"></div>

                        <div>
                            <h2 className="rsvp-blue-header">Pick your meal</h2>
                            <p style={{ margin: "20px auto", textAlign: "center", width: "80%" }}>Let us know what you'd like to eat!</p>
                            <p style={{ fontWeight: 'bold' }}>Your Meal Selection</p>
                            <form>
                                <label>Starter</label>
                                <select
                                    value={guestStarter}
                                    disabled={true}
                                >
                                    <option value="">Please select a starter</option>
                                    {weddingData?.meals?.filter(meal => meal.course === 'Starter').map((meal, index) => (
                                        <option key={index} value={meal.name}>{meal.name}</option>
                                    ))}
                                    <option value="Skip this course">Skip this course</option>
                                </select>

                                <label>Main</label>
                                <select
                                    value={guestMain}
                                    disabled={true}
                                >
                                    <option value="">Please select a main course</option>
                                    {weddingData?.meals?.filter(meal => meal.course === 'Main').map((meal, index) => (
                                        <option key={index} value={meal.name}>{meal.name}</option>
                                    ))}
                                    <option value="Skip this course">Skip this course</option>
                                </select>

                                <label>Dessert</label>
                                <select
                                    value={guestDessert}
                                    disabled={true}
                                >
                                    <option value="">Please select a dessert</option>
                                    {weddingData?.meals?.filter(meal => meal.course === 'Dessert').map((meal, index) => (
                                        <option key={index} value={meal.name}>{meal.name}</option>
                                    ))}
                                    <option value="Skip this course">Skip this course</option>
                                </select>

                                <label>Dietary Requirements</label>
                                <textarea
                                    value={guestDietary}
                                    rows={3}
                                    readOnly={true}
                                />
                            </form>

                        </div>

                        <div className="rsvp-line-break"></div>
                        </>
                        )}

                        {!showMealChoicesForGuest(previewInvitedTo, weddingData) && guestData?.plusOnes && guestData.plusOnes.length > 0 && (
                            <div className="rsvp-line-break"></div>
                        )}

                        {guestData?.plusOnes && guestData.plusOnes.length > 0 && (
                            <>
                                <div id='plus-one-container'>
                                    <h2 className="rsvp-blue-header">Your plus {guestData.plusOnes.length > 1 ? 'ones' : 'one'}</h2>
                                    <p style={{
                                        textAlign: 'center',
                                        color: '#666',
                                        fontSize: '14px',
                                        fontStyle: 'italic',
                                        maxWidth: '500px',
                                        margin: '10px auto 0',
                                        lineHeight: 1.5,
                                    }}>
                                        This section only appears for guests who have plus-ones on their invitation. Sample data is shown here for preview.
                                    </p>
                                    <p style={{ margin: "20px auto", textAlign: "center", width: "80%" }}>
                                        Your confirmed guest{guestData.plusOnes.length > 1 ? 's' : ''} details
                                    </p>

                                    {guestData.plusOnes.map((plusOne, index) => (
                                        <div key={index} style={{ marginBottom: '40px' }}>
                                            {guestData.plusOnes.length > 1 && (
                                                <p style={{ fontWeight: 'bold', fontSize: '18px', marginBottom: '20px', color: '#4D8495' }}>
                                                    Guest {index + 1}
                                                </p>
                                            )}

                                            <p style={{ fontWeight: 'bold' }}>Guest Details</p>
                                            <form>
                                                <label>Name</label>
                                                <input
                                                    type="text"
                                                    value={plusOne.name}
                                                    readOnly={true}
                                                />
                                                <label>Age</label>
                                                <div style={{
                                                    display: 'flex',
                                                    gap: '10px',
                                                    marginTop: '10px',
                                                    marginBottom: '20px',
                                                    flexWrap: 'wrap'
                                                }}>
                                                    {['Adult', 'Child', 'Baby'].map((ageOption) => (
                                                        <button
                                                            key={ageOption}
                                                            type="button"
                                                            disabled={true}
                                                            style={{
                                                                flex: '1',
                                                                minWidth: '80px',
                                                                padding: '10px 20px',
                                                                borderRadius: '25px',
                                                                cursor: 'not-allowed',
                                                                transition: 'all 0.2s ease',
                                                                backgroundColor: plusOne.age === ageOption ? '#48688D' : 'white',
                                                                color: plusOne.age === ageOption ? 'white' : '#454C5C',
                                                                fontWeight: plusOne.age === ageOption ? 'bold' : 'normal',
                                                                border: plusOne.age === ageOption ? 'none' : '1px solid #B0ADAD',
                                                                opacity: 0.6
                                                            }}
                                                        >
                                                            {ageOption}
                                                        </button>
                                                    ))}
                                                </div>

                                                {plusOne.age === 'Baby' && (
                                                    <div style={{ marginTop: '10px', marginBottom: '20px' }}>
                                                        <p style={{ color: '#454C5C', marginBottom: '15px' }}>{showMealChoicesForGuest(previewInvitedTo, weddingData) ? 'Do you require either of the following?' : 'Do you require the following?'}</p>
                                                        {showMealChoicesForGuest(previewInvitedTo, weddingData) && (
                                                        <label style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            marginBottom: '15px',
                                                            cursor: 'not-allowed',
                                                            opacity: 0.6
                                                        }}>
                                                            <div
                                                                style={{
                                                                    width: '28px',
                                                                    height: '28px',
                                                                    borderRadius: '5px',
                                                                    marginRight: '12px',
                                                                    cursor: 'not-allowed',
                                                                    backgroundColor: plusOne.noMealNeeded ? '#48688D' : 'white',
                                                                    border: plusOne.noMealNeeded ? 'none' : '1px solid #B0ADAD',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    transition: 'all 0.2s ease',
                                                                    flexShrink: 0
                                                                }}
                                                            >
                                                                {plusOne.noMealNeeded && (
                                                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                                        <path d="M13.5 4L6 11.5L2.5 8" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                                    </svg>
                                                                )}
                                                            </div>
                                                            <span style={{ fontSize: '14px', color: '#454C5C' }}>No meal needed</span>
                                                        </label>
                                                        )}
                                                        <label style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            cursor: 'not-allowed',
                                                            opacity: 0.6
                                                        }}>
                                                            <div
                                                                style={{
                                                                    width: '28px',
                                                                    height: '28px',
                                                                    borderRadius: '5px',
                                                                    marginRight: '12px',
                                                                    cursor: 'not-allowed',
                                                                    backgroundColor: plusOne.needsHighChair ? '#48688D' : 'white',
                                                                    border: plusOne.needsHighChair ? 'none' : '1px solid #B0ADAD',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    transition: 'all 0.2s ease',
                                                                    flexShrink: 0
                                                                }}
                                                            >
                                                                {plusOne.needsHighChair && (
                                                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                                        <path d="M13.5 4L6 11.5L2.5 8" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                                    </svg>
                                                                )}
                                                            </div>
                                                            <span style={{ fontSize: '14px', color: '#454C5C' }}>Please reserve a high chair</span>
                                                        </label>
                                                    </div>
                                                )}
                                            </form>

                                            {showMealChoicesForGuest(previewInvitedTo, weddingData) && !(plusOne.age === 'Baby' && plusOne.noMealNeeded) && (
                                                <>
                                                    <p style={{ fontWeight: 'bold', marginTop: '30px' }}>Meal Selection</p>
                                                    <p style={{ color: "#4D8495", margin: "20px 0" }}>Let us know what your guest would like to eat!</p>
                                                    <form>
                                                        <label>Starter</label>
                                                        <select
                                                            value={plusOne.starter}
                                                            disabled={true}
                                                        >
                                                            <option value="">Please select a starter</option>
                                                            {weddingData?.meals?.filter(meal => meal.course === 'Starter').map((meal, mealIndex) => (
                                                                <option key={mealIndex} value={meal.name}>{meal.name}</option>
                                                            ))}
                                                            <option value="Skip this course">Skip this course</option>
                                                        </select>

                                                        <label>Main</label>
                                                        <select
                                                            value={plusOne.main}
                                                            disabled={true}
                                                        >
                                                            <option value="">Please select a main course</option>
                                                            {weddingData?.meals?.filter(meal => meal.course === 'Main').map((meal, mealIndex) => (
                                                                <option key={mealIndex} value={meal.name}>{meal.name}</option>
                                                            ))}
                                                            <option value="Skip this course">Skip this course</option>
                                                        </select>

                                                        <label>Dessert</label>
                                                        <select
                                                            value={plusOne.dessert}
                                                            disabled={true}
                                                        >
                                                            <option value="">Please select a dessert</option>
                                                            {weddingData?.meals?.filter(meal => meal.course === 'Dessert').map((meal, mealIndex) => (
                                                                <option key={mealIndex} value={meal.name}>{meal.name}</option>
                                                            ))}
                                                            <option value="Skip this course">Skip this course</option>
                                                        </select>

                                                        <label>Dietary Requirements</label>
                                                        <textarea
                                                            value={plusOne.dietaryRequirements}
                                                            rows={3}
                                                            readOnly={true}
                                                        />
                                                    </form>
                                                </>
                                            )}
                                        </div>
                                    ))}


                                </div>
                                <div className="rsvp-line-break"></div>
                            </>
                        )}

                    </>
                }

                {canAttend === false &&
                    <div id='decline-container' style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <div className="rsvp-flourish rsvp-flourish-miss">
                            <img src={heartsLeft} alt="" className="rsvp-flourish-left" />
                            <h2 className="rsvp-blue-header" style={{ color: '#323232' }}>You'll be<br /> missed!</h2>
                            <img src={heartsRight} alt="" className="rsvp-flourish-right" />
                        </div>

                        <p className='rsvp-subheader-black' style={{ marginTop: 20 }}>THANKS FOR YOUR RESPONSE — we'll MISS celebratING WITH YOU!</p>
                        <div className="rsvp-line-break"></div>

                    </div>
                }


                {canAttend === true && (
                    <>
                        <div id='accept-container' style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <div className="rsvp-flourish">
                                <img src={starsLeft} alt="" className="rsvp-flourish-left" />
                                <h2 className="rsvp-blue-header" style={{ color: '#323232' }}>Thanks <br /> for your <br /> response!</h2>
                                <img src={starsRight} alt="" className="rsvp-flourish-right" />
                            </div>

                            <p className='rsvp-subheader-black' style={{ marginTop: 20 }}>We're so excited to see you<br /> on the big day.</p>

                        </div>

                        <div className="rsvp-line-break"></div>

                        <div style={{ textAlign: 'center', margin: '40px 0' }}>
                            <p style={{
                                color: '#4D8495',
                                fontSize: '18px',
                                fontWeight: 'bold',
                                marginBottom: '10px'
                            }}>
                                RSVP Preview
                            </p>
                            <p style={{
                                color: '#666',
                                fontSize: '14px',
                                maxWidth: '500px',
                                margin: '0 auto',
                                lineHeight: 1.5,
                            }}>
                                This is how your RSVP will appear to guests. All fields use sample data for demonstration.
                                Use the toggle above to preview all-day vs evening-only invitations (evening guests will not see meal choices).
                                Guests without plus-ones on their invitation will not see a plus-one section.
                            </p>
                        </div>
                    </>
                )}

                <WeddingWebsiteCallout friendlyURL={weddingData?.friendlyURL} />

                <a href='https://firstdance.app' target='_blank' style={{ textDecoration: 'unset' }}>
                    <p className='rsvp-subheader-black' >Sent With</p>
                    <img src={fdm} style={{ height: 100, width: 120, objectFit: 'contain' }} />
                </a>
            </div >
        </>
    )
}

export default RSVPPreview

